angular.module('elogbooksServices').service('frontendPaginationService', function() {
        this.getAllPaginated = function (collection, page, limit) {
            const itemsPaginated = {
                count: collection.length,
                page: page,
                limit: limit,
                pages: Math.trunc((collection.length / limit) + 1),
                items: []
            };

            if (collection.length > limit) {
                let index = (page - 1) * limit;
                let count = 0;

                while (collection.length > index && count < limit) {
                    itemsPaginated.items.push(collection[index]);
                    index++;
                    count++;
                }
            } else if (collection.length > 0) {
                itemsPaginated.items = collection;
            }

            return itemsPaginated;
        }

    return this;
});
